<template>
<div class="outer">
  <input type="number" class="inputNo" v-model="no" @click.once="triggerGuess"><br>
  <div class="hintBox">
    <p class="hintTxt">{{hint}}</p>
    <p class="record" v-for="(i, key) in guessArray" :key="key">{{i.time}}{{i.no}}</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'GuessNo',
  data () {
    return {
      randomNumber: undefined,
      time: 0,
      countTime: undefined,
      guessArray: [],
      no: '',
      hint: '猜一个0~100的整数'
    }
  },
  methods: {
    countTimeFc () {
      this.countTime = setInterval(() => {
        this.time += 1
        this.guessArray[0].time = this.time
      }, 0)
    },
    triggerGuess () {
      this.randomNumber = Math.round(Math.random() * 100)
      this.guessArray.unshift({time: this.time, no: ''})
      this.countTimeFc()
    }
  },
  watch: {
    no (val) {
      if (val < this.randomNumber) {
        this.hint = '小了'
      } else if (val > this.randomNumber) {
        this.hint = '大了'
      } else if (+val === this.randomNumber) {
        this.hint = '对啦，再猜一个...吧?'
        this.guessArray[0].no = ':' + val
        this.time = 0
        this.guessArray.unshift({time: this.time, no: ''})

        clearInterval(this.countTime)

        this.randomNumber = Math.round(Math.random() * 100)
        this.countTimeFc()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

.outer{

  $bgColor = #2b2f32

  position absolute
  width 100vw
  height 100vh
  background #2b2f32
  .inputNo{
    height: 5rem;
    width: 60%;
    font-size: 2em;
    margin: 5rem 0 0 20%;
    text-align: center;
    background #8e8e8e
  }
  .hintBox{
    text-align: center;
    font-size: 2em;
    color #cecece
    .record{
      color #8e8e8e
    }
  }
}
</style>
